<template lang="pug">
    div#app
        input(placeholder="来者何人？",v-model="name",v-if="name!=='栗子'")
        template(v-if="name==='栗子'")
            Heart
            div.tb
                div.text(class="animated bounceInLeft delay-0s") 栗儿
                div.text(class="animated bounceInRight delay-1s") 就知道是你
                div.text(class="animated flipInX delay-2s") 亲爱的
                div.text(class="animated fadeIn delay-3s") I Love You !
</template>

<script>
import Heart from "./Heart"
import "animate.css/animate.min.css"
export default {
    data:function(){
        return {
            name:""
        }
    },
    components:{
        Heart
    }
}
</script>

<style lang="less">

    #app{
        background: #eee;
        height: 100vh;
        width:100vw;
        input{
            position:relative;
            left:50%;
            top:10%;
            transform:translateX(-50%);
            outline: none;
            border-radius: 10px 10px 50% 50%;
            line-height: 2em;
            font-size:1.5em;
            border:none;
            text-align: center;
            background: none;
            border-bottom:solid 3px red;
        }
        .tb{
            width:100%;
            position:relative;
            .text{
                font-family:cursive,"kaiti";
                font-size:3em;
                margin:0 auto;
                text-align: center;
                position: absolute;
                width:100%;
                &:nth-child(1){
                    color:blueviolet
                }
                &:nth-child(2){
                    top:2em;
                    color:yellow;
                }
                &:nth-child(3){
                    top:8em;
                    color:tomato;
                }
                &:nth-child(4){
                    top:4em;
                }
            }
        }
    }
</style>